import styled from 'styled-components'
import { media, colors } from 'styles'

const borderRadius = '1.5rem'

const StyledConfirmEmail = styled.div`
  max-width: 65rem;
  position: relative;
  border-radius: ${borderRadius};
  background-color: ${colors.mainBackground};
  color: ${colors.textMain};

  header {
    font-size: 1.4rem;
    text-align: center;
    overflow: hidden;
    text-transform: uppercase;
    font-weight: 700;
  }
  .username {
    color: ${colors.cta};
  }
  .resend {
    display: block;
    margin: 2rem auto 0;
  }
  .body {
    padding: 3rem;
    box-sizing: border-box;
    text-align: center;
  }
  .confirmation-text {
    font-size: 1.3rem;
    line-height: 1.6;
  }

  .current-email {
    display: inline-block;
    margin: 2rem 0;
    padding: 1.2rem 4.5rem;
    border: 0.1rem solid ${colors.cta};
    font-weight: 700;
    font-size: 1.4rem;
    text-transform: uppercase;
  }

  .additional-information {
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 1px solid ${colors.divider};

    .text {
      margin-bottom: 2rem;
      font-size: 1.2rem;
      line-height: 1.6;
    }

    .action {
      display: inline-block;
      cursor: pointer;
      margin: 1rem;
    }
  }

  .resend-email {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size: 1.1rem;
    text-align: center;

    input {
      width: 24rem;
      padding: 0.8rem 1.5rem;
      text-align: center;
      font-size: 1.2rem;
      background: ${colors.mainBackground};

      &::placeholder {
        color: #9b9b9b;
      }

      &:focus {
        outline: none;
      }
    }
    [type='submit'] {
      margin-top: 2rem;
    }
    .current-email:focus {
      box-shadow: inset 0 0 0px 2px #ff6600;
    }
  }
  .form-msg {
    margin-top: 1.5rem;
    color: ${colors.mainBackground};
  }
  ${media.mobile`
    .current-email {
      display: block;
      max-width: 100%;
      overflow: auto;
      padding: 2rem;
    }
  `}
`

export default StyledConfirmEmail
